import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateSendAvailableDataState,
	globalStateSendAvailableDataReducer,
	globalStateSendAvailableDataAction,
} from "./data";

export type StateSendAvailable = {
	data: globalStateSendAvailableDataState;
};

export const sendAvailable = combineReducers<StateSendAvailable>({
	data: globalStateSendAvailableDataReducer,
});

export const globalStateSendAvailableAction = {
	data: globalStateSendAvailableDataAction,
};

export default sendAvailable;
